import { NgClass } from '@angular/common';
import { Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  imports: [NgClass, SpinnerComponent],
})
export class ButtonComponent {
  public type = input<'button' | 'submit'>('button');
  public disabled: InputSignal<boolean> = input(false);
  public fullWidth: InputSignal<boolean> = input(false);
  public isLoading: InputSignal<boolean> = input(false);
  public small: InputSignal<boolean> = input(false);
  public text: InputSignal<string> = input.required();
  public variant = input<'primary' | 'secondary' | 'ghost' | 'alert'>('primary');

  @Output() clicked = new EventEmitter<void>();
}
